export const defaultGlobalObjectKey = 'faro';
